import React, { Fragment } from "react";

const SnippetSpan = ({ copy, clickable }) => {
  return (
    <Fragment>
      <div className="token-monospace f6">{copy}</div>
      <style jsx>
        {`
          .token-monospace {
            font-family: "Menlo", monspace;
            color: rgba(0, 0, 0, 0.6);
          }

          .token-monospace:hover {
            color: ${clickable ? "#383838" : "rgba(0, 0, 0, 0.6)"};
          }
        `}
      </style>
    </Fragment>
  );
};

export default SnippetSpan;
